// =====================================
//
//   付款結果 Controller
//   Author: Gray
//   createtime: 2016 / 03 / 11
//	 updatetime: 2016 / 03 / 11
//
// =====================================

window.InifECMobileApp.controller("ExtrafeePaymentResultController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'UserService', 'ExtraFeeService',
	function($scope, $state, $timeout, $rootScope, $stateParams, UserService, ExtraFeeService) {

        var init = function() {
            
            $scope.isLoading = true;

            // 通知app 關掉付款web view
            var msg = {
                type: 'paymentFinishedCallback',
            }

            msg = JSON.stringify(msg);

            // post state change message
            if( window.WebViewBridge !== undefined && window.WebViewBridge.postMessage){
                window.WebViewBridge.postMessage(msg);
            } else if( window.WebViewBridge !== undefined && window.WebViewBridge.send){
                window.WebViewBridge.send(msg);
            }

            if(!$scope.isError) {

                $timeout(function() {
                    checkResult();
                }, 500);

            } else {
                UserService.getUserInfo().then(function(result) {
                    $scope.isLogin = true;
                    $scope.isLoading = false;
                }, function(error) {
                    $scope.isLogin = false;

                    $state.go(window.STATES.HOME);
                });
            }
        }

        var checkResult = function() {

            if($scope.checkCount++ > 4) {
                $scope.isLoading = false;
                $scope.isError = true;
                $scope.errorcode = "系統錯誤";
                $scope.errordesc = "系統發生無法預期錯誤，請重新再試";
                return;
            }

            ExtraFeeService.getExtraFee($scope.extrafeeid).then(function(result) {

                if(result && result.status >= 400) {
                    
                    // $state.go(window.STATES.EXTRAFEE, {
                    //     extrafeeid: $scope.extrafeeid,
                    //     orderid: result.orderid
                    // });

                    $state.go(window.STATES.ORDER, {
                        orderid: $scope.orderid
                    });

                } else if(result && result.status < 400) {

                    $timeout(function() {
                        checkResult();
                    }, 500);

                } else {
                    $scope.isLoading = false;
                    $scope.isError = true;
                    $scope.errorcode = "系統錯誤";
                    $scope.errordesc = "系統發生無法預期錯誤，請重新再試";
                }

            }, function(error) {

                $scope.isLoading = false;
                $scope.isError = true;
                $scope.errorcode = "系統錯誤";
                $scope.errordesc = "系統發生無法預期錯誤，請重新再試";

            });
        }

	    //==========================
        //  Events
        //==========================
        $scope.$on("LOGOUT_SUCCESS", function(event, data) {
            init();
        });

        //==========================
        //  Members
        //==========================
        $scope.extrafeeid = $stateParams.extrafeeid;
        $scope.errorcode = $stateParams.errorcode;
        $scope.errordesc = $stateParams.errordesc;
        $scope.isError = $stateParams.errorcode;
        $scope.checkCount = 0;


        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        init();
	}
]);